var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Content',[_c('Stage',[_c('VideoWithButton',{attrs:{"header":_vm.$t('camera_check_header'),"body":_vm.$t('camera_check_pre_exam_accepted')},on:{"video-confirmed":_vm.confirmedHandler}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }